import React, {useMemo, useEffect, useState} from "react";
import objectPath from "object-path";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import {Topbar} from "./Topbar";
import {HeaderMenuWrapper} from "./header-menu/HeaderMenuWrapper";
import {AnimateLoading} from "../../../_partials/controls";
import { useDispatch, useSelector } from "react-redux";
import { authSagaActions } from "../../../../app/modules/Auth";
import { provinceSagaActions } from "../../../../app/modules/Administration/ProvinceInfoManagement";
import classes from "./Header.module.css";


export function Header() {


  const dispatch = useDispatch();

  const { auth, province } = useSelector((state) => state);

  const [provinceName, setProvinceName] = useState("");

  useEffect(()=>{

    dispatch(authSagaActions.loadLogo(auth.user.prov_agency_id));
    dispatch(provinceSagaActions.fetchProvinces({ id: auth.user.prov_agency_id.toString() }));

  },[dispatch,auth.user.prov_agency_id]);

  useEffect(() => {
    if(province.provinces.length > 0 ){
      let name = province.provinces[0].name;
      let provName = "";
      if (name === "Northern (Oro Province)" || name === "Bougainville (North Solomons)" || name === "Western Province (Fly River)" || name === "National Capital District"){
        provName = name;
      } else {
        provName = name + " Province";
      }
      setProvinceName(provName);
    }
  }, [province]);

  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      headerClasses: uiService.getClasses("header", true),
      headerAttributes: uiService.getAttributes("header"),
      headerContainerClasses: uiService.getClasses("header_container", true),
      menuHeaderDisplay: objectPath.get(
        uiService.config,
        "header.menu.self.display"
      )
    };
  }, [uiService]);

  return (
    <>
      {/*begin::Header*/}
      <div
        className={`header ${layoutProps.headerClasses}`}
        id="kt_header"
        {...layoutProps.headerAttributes}
      >
        {/*begin::Container*/}
        <div className={` ${layoutProps.headerContainerClasses} d-flex align-items-stretch justify-content-between`}>
          <AnimateLoading />
          {auth.logo &&
          <div className={`col-lg-6 ${classes['dept-logo']}`}>
            <img src={auth.logo.base64String} alt={auth.logo.name} />
            <h4 style={{marginTop:"40px"}}>{auth.logo.name}</h4>
            <h5 className="text-muted"> {provinceName} </h5>
          </div>}
          {/*begin::Header Menu Wrapper*/}
          {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />}
          {!layoutProps.menuHeaderDisplay && <div />}
          {/*end::Header Menu Wrapper*/}

          {/*begin::Topbar*/}
          <Topbar />
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>
      {/*end::Header*/}
    </>
  );
}
